import { ASAP, dateHelper } from '@cakeiteasy/web-utils';

export class BakeryOrdersDeliveryOrderModel {
  public id?: number = null;
  public number = '';
  public type = '';
  public price = null;
  public priceWithoutVat = null;
  public deliveryDate = null;
  public deliveryTime = '';
  public deliveryPostNumber = '';
  public deliveryCity = '';
  public deliveryNote = '';
  public deliveryPhone = '';
  public deliveryAddress = '';
  public deliveryUserName = '';
  public deliverySecondaryAddress = '';
  public deliveryAgent?: number = null;
  public outlet = null;
  public deliveryDateIsValid?: boolean = null;
  public deliveryType = null;
  public deliveryEmail?: string = '';
  public sendEmailDate?: any = null;
  public sendEmailTime?: string = '';
  public messageToRecipient?: string = '';

  public orderId?: number = null;
}
